/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Type_OutInputs */

const vi_product_lot_history_type_out = /** @type {(inputs: Product_Lot_History_Type_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PXK`)
};

/**

* @param {Product_Lot_History_Type_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_type_out = /** @type {((inputs?: Product_Lot_History_Type_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Type_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_type_out(inputs)
});